<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  <p>{{message}}</p>
</div>

<div mat-dialog-actions>
  <lib-button variant="raised" (buttonClick)="onConfirm()">Ok</lib-button>
</div>
